module.exports = __webpack_public_path__ + "static/media/filter-date.101fbecd.png";